import NotificationProvider from './NotificationProvider.component';
export default NotificationProvider;
